import { queryOptions, useQuery } from "@tanstack/react-query"
import { apiFetch } from "../utils/apiFetch"
import type { TExercise } from "../utils/workoutUtils"

export const fetchExercisesQueryOptions = queryOptions({
  queryKey: ["exercises"],
  queryFn: () => apiFetch<Array<TExercise>>("/v1/exercises"),
})

export function useExercises() {
  return useQuery(fetchExercisesQueryOptions)
}
